import React from 'react';

const Icon117OrientationSleeperLeft = props => (
  <svg
    focusable="false"
    viewBox="0 0 800 800"
    aria-hidden="true"
    role="presentation"
    {...props}
  >
    <rect
      x="503.18"
      y="296.82"
      width="216.75"
      height="216.75"
      transform="translate(1016.75 -206.35) rotate(90)"
      fill="transparent"
      stroke="currentColor"
      strokeLinejoin="round"
      strokeWidth="10"
    />
    <path
      d="M503.18,80.07h216.75v216.75h-202.25c-8,0-14.5-6.5-14.5-14.5V80.07h0Z"
      transform="translate(800 -423.1) rotate(90)"
      fill="transparent"
      stroke="currentColor"
      strokeLinejoin="round"
      strokeWidth="10"
    />
    <path
      d="M772.17,38.08v41.99s0,216.75,0,216.75h-52.25s0-216.75,0-216.75h-206.49c-5.66,0-10.26-4.59-10.26-10.26v-31.73c0-5.66,4.59-10.26,10.26-10.26h248.48c5.66,0,10.26,4.59,10.26,10.26Z"
      fill="transparent"
      stroke="currentColor"
      strokeLinejoin="round"
      strokeWidth="10"
    />
    <g>
      <rect
        x="503.18"
        y="513.57"
        width="216.75"
        height="216.75"
        transform="translate(-10.4 1233.5) rotate(-90)"
        fill="transparent"
        stroke="currentColor"
        strokeLinejoin="round"
        strokeWidth="10"
      />
      <path
        d="M625.93,616.75h23.49c5.07,0,9.18,4.11,9.18,9.18v259.82h-32.67c-5.07,0-9.18-4.11-9.18-9.18v-250.64c0-5.07,4.11-9.18,9.18-9.18Z"
        transform="translate(-113.57 1388.92) rotate(-90)"
        fill="transparent"
        stroke="currentColor"
        strokeLinejoin="round"
        strokeWidth="10"
      />
      <path
        d="M637.67,595.82h216.75v43.25c0,4.97-4.03,9-9,9h-198.75c-4.97,0-9-4.03-9-9v-43.25h0Z"
        transform="translate(124.1 1368) rotate(-90)"
        fill="transparent"
        stroke="currentColor"
        strokeLinejoin="round"
        strokeWidth="10"
      />
    </g>
    <line
      x1="719.93"
      y1="296.82"
      x2="503.18"
      y2="296.82"
      fill="transparent"
      stroke="currentColor"
      strokeLinejoin="round"
      strokeWidth="10"
    />
    <g>
      <rect
        x="286.43"
        y="80.07"
        width="216.75"
        height="216.75"
        fill="transparent"
        stroke="currentColor"
        strokeLinejoin="round"
        strokeWidth="10"
      />
      <path
        d="M295.43,27.83h198.75c4.97,0,9,4.03,9,9v43.25h-216.75v-43.25c0-4.97,4.03-9,9-9Z"
        fill="transparent"
        stroke="currentColor"
        strokeLinejoin="round"
        strokeWidth="10"
      />
      <g>
        <rect
          x="69.68"
          y="80.07"
          width="216.75"
          height="216.75"
          fill="transparent"
          stroke="currentColor"
          strokeLinejoin="round"
          strokeWidth="10"
        />
        <path
          d="M37.01,27.83h32.67v259.82c0,5.07-4.11,9.18-9.18,9.18h-23.49c-5.07,0-9.18-4.11-9.18-9.18V37.01c0-5.07,4.11-9.18,9.18-9.18Z"
          fill="transparent"
          stroke="currentColor"
          strokeLinejoin="round"
          strokeWidth="10"
        />
        <path
          d="M78.68,27.83h198.75c4.97,0,9,4.03,9,9v43.25H69.68v-43.25c0-4.97,4.03-9,9-9Z"
          fill="transparent"
          stroke="currentColor"
          strokeLinejoin="round"
          strokeWidth="10"
        />
        <path
          d="M78.68,80.07h415.5c4.97,0,9,4.03,9,9v537.37H69.68V89.07c0-4.97,4.03-9,9-9Z"
          transform="translate(572.86 706.52) rotate(180)"
          fill="transparent"
          stroke="currentColor"
          strokeDasharray="15"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="6"
        />
      </g>
    </g>
    <rect
      x="637.67"
      y="379.07"
      width="216.75"
      height="52.25"
      transform="translate(1151.25 -340.85) rotate(90)"
      fill="transparent"
      stroke="currentColor"
      strokeLinejoin="round"
      strokeWidth="10"
    />
  </svg>
);

export default Icon117OrientationSleeperLeft;
